<template>
    <table class="font-basier block lg:table lg:table-auto w-full">
        <slot></slot>
    </table>
</template>
